import { render, staticRenderFns } from "./AnswerCreateOrEdit.vue?vue&type=template&id=6f98197c&"
import script from "./AnswerCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./AnswerCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports